"use client";

import { useCallback } from "react";

/**
 * Otel detay sayfasında "share" aksiyonu için dataLayer event push eder.
 *
 * istenen payload:
 * window.dataLayer.push({
 *   event: "custom_event",
 *   event_category: "custom_event",
 *   event_action: "share_hotel",
 *   hotel_name: "Kordon Hotel Cankaya"
 * });
 */
export function useHotelShareAnalytics() {
  const trackShareHotel = useCallback((hotelName) => {
    if (typeof window === "undefined") return;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "custom_event",
      event_category: "custom_event",
      event_action: "share_hotel",
      hotel_name: hotelName ?? "",
    });
  }, []);

  return { trackShareHotel };
}

